<template>
    <div class="d-flex flex-column w-100">
        <v-offline 
        online-class="online"
        offline-class="offline"
        @detected-condition="onConnectionChange">
            <template v-if="online">
            <div class="flex w-full h-full justify-center items-center text-6xl">
                
            </div>
            </template>
            <template v-if="!online">
            <div class="flex w-full h-full justify-center items-center text-6xl">
                
            </div>
            </template>
        </v-offline>
        <div class="d-flex ml-5 align-items-center mx-auto">
            
            <img src="@/assets/images/logo/logoNew.png" width="200"/>
            
        </div>
        <br></br>
        <b-form-group class="ml-1 mr-1 flex-fill " label="Seleccione Finca">
            <v-select v-model="farm_id" :options="farms" :value="farms.value" placeholder="Seleccione Finca" label="text" append-outer-icon="mdi-map"></v-select>
        </b-form-group>
        <b-nav vertical class="ml-1">
            <b-nav-item to="/"> Inicio </b-nav-item>
            <b-nav-item to="/basicHome/Report">Reportes</b-nav-item>
            <b-nav-item to="/basicHome/addUser">Admin. Usuarios</b-nav-item>
            <b-nav-item to="/account-settings">Configurar Cuenta</b-nav-item>
            <b-nav-item to="/cancel-account">Cancelar Cuenta</b-nav-item>
        </b-nav>
        
    </div>
    
</template>


<script>
import {BImg,BFormGroup, BNav, BNavItem } from 'bootstrap-vue';
//import { ref } from 'vue';
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import flatPickr from 'vue-flatpickr-component';
import { VOffline } from 'v-offline';
    export default {
        components: {
            BImg,
            BNav,
            BNavItem,
            vSelect,
            flatPickr,
            BFormGroup,
            VOffline,
        },
        data() {
            return {
                farms:[],
                online:false,
                farm_id:0
            }
        },
        methods: {
            async fetchFarms(config){
                let self=this;
                if(this.online){
                    fetch(this.$apiUrl+"list/FarmsViews?recperpage=all", config)
                    .then(response => response.json())
                    .then(result => {
                        console.log(result.FarmsViews);
                        this.farms = result.FarmsViews.map(item => {return {value:item.id,text:item.cvo+ '-'+ item.name}});
                        console.log(self.farms);
                        self.fetchFarmsPermissions(config);
                    }).catch(error => {
                        this.$swal({
                            title: 'Sesión',
                            text: 'El tiempo de sesión ha vencido, ingresa nuevamente.',
                            type: 'warning',
                            icon:'warning',
                            showCancelButton: false,
                            confirmButtonColor:'#5E8F23',
                            showCloseButton: true,
                            showLoaderOnConfirm: false  
                        }).then(function(){
                            console.log(error)
                            localStorage.removeItem('userID');
                            localStorage.removeItem('accessToken');
                            localStorage.removeItem('userMeta');
                            localStorage.removeItem('userData');
                            localStorage.removeItem('currentFarm');
                            localStorage.removeItem('currentFarmName');
                            localStorage.removeItem('refreshToken');
                            self.$router.push('/login');
                        });
                        
                    });
                }else{
                    let localfarms= JSON.parse(localStorage.getItem('sidebarFarms'));
                    if (localfarms.length>0){
                        this.farms=localfarms.map(item => {return {value:item.value,text:item.text}});
                        console.log(this.farms)
                    }
                    
                }
                
            },       
            async fetchFarmsPermissions(config){
                let self=this;
                fetch(this.$apiUrl+"list/UsersFarmView?recperpage=all", config)
                .then(response => response.json())
                .then(result => {
                    console.log('Listando fincas compartidas');
                    console.log(result);
                    result.UsersFarmView.map(item => {
                        if(item.user_id==localStorage.getItem('userID')){
                            this.farms.push({value:item.farm_id, text:item.farm_name +' - '+ item.level})        
                        }
                    });
                    console.log(this.farms);
                    localStorage.setItem('sidebarFarms',JSON.stringify(self.farms));
                    if(!self.farms.length){
                        this.$swal({
                            title: 'Fincas',
                            text: 'Debe crear una finca o tener acceso a una de invitado para usar las herramientas.',
                            type: 'warning',
                            icon:'warning',
                            showCancelButton: false,
                            confirmButtonColor:'#5E8F23',
                            showCloseButton: true,
                            showLoaderOnConfirm: false}).then(function(){
                                self.$router.push('/advanceHome/Farm/CreateFarm');
                            });
                    }
                    /* let current= localStorage.getItem('currentFarm');
                    if(!current){
                        this.$swal({
                            title: 'Fincas',
                            text: 'Debe seleccionar una finca para usar las herramientas.',
                            type: 'warning',
                            icon:'warning',
                            showCancelButton: false,
                            confirmButtonColor:'#5E8F23',
                            showCloseButton: true,
                            showLoaderOnConfirm: false}).then(function(){
                                self.$router.push('/');
                        });
                    } */
                }).catch(error => {
                    this.$swal({
                        title: 'Sesión',
                        text: 'El tiempo de sesión ha vencido, ingresa nuevamente.',
                        type: 'warning',
                        icon:'warning',
                        showCancelButton: false,
                        confirmButtonColor:'#5E8F23',
                        showCloseButton: true,
                        showLoaderOnConfirm: false  
                    }).then(function(){
                        console.log(error)
                        localStorage.removeItem('userID');
                        localStorage.removeItem('accessToken');
                        localStorage.removeItem('userMeta');
                        localStorage.removeItem('userData');
                        localStorage.removeItem('currentFarm');
                        localStorage.removeItem('currentFarmName');
                        localStorage.removeItem('refreshToken');
                        self.$router.push('/login');
                    });
                    
                });

                
            },  
            onConnectionChange(val){
                this.online=val;
                console.log(val);
            }  

        },
        watch:{
            'farm_id': function(value){
                console.log(value.value);
                localStorage.setItem("currentFarm",value.value);
                localStorage.setItem("currentFarmName",value.text);
                const perfil = value.text.includes(" - ") ? value.text.split(" - ")[1] : "Administrador";
                localStorage.setItem("currentLevelAccess", perfil);
                this.$router.replace('/');
                //localStorage.setItem("currentLevelAccess", value.text.split(" - ")[1]);
            },
        },
        created() {
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            this.online=navigator.onLine;
            this.fetchFarms(config);
        }
    }
</script>

<style>
.nav-item a{
    color:#2f2f2f !important;
}
</style>